import React, { useMemo } from "react";
import useSeo from "../seo/useSeo";
import useJsonLd from "../seo/useJsonLd";
import ImagesToPdf from "../components/ImagesToPdf";

export default function FusionJpgToPdfPage() {
  useSeo({
    title:
      "Fusion JPG en PDF – Regrouper plusieurs images en un PDF | pdf-convert.fr",
    description:
      "Regroupez plusieurs images (JPG/PNG/WebP) en un seul PDF A4. Ordre modifiable, zoom max, conversion locale.",
    canonical: "https://pdf-convert.fr/fusion-jpg-pdf",
  });

  const faqItems = [
    {
      q: "Comment fusionner plusieurs images en PDF ?",
      a: "Ajoutez plusieurs images, réorganisez l’ordre, puis générez le PDF. Vous pouvez le télécharger immédiatement.",
    },
    {
      q: "Le PDF est-il au format A4 ?",
      a: "Oui, le PDF est généré en A4 et les images remplissent la page au maximum (zoom max).",
    },
    {
      q: "Mes fichiers sont-ils envoyés sur un serveur ?",
      a: "Non, tout se fait localement dans votre navigateur.",
    },
  ];

  const faqJsonLd = useMemo(
    () => ({
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: faqItems.map((it) => ({
        "@type": "Question",
        name: it.q,
        acceptedAnswer: { "@type": "Answer", text: it.a },
      })),
    }),
    []
  );

  useJsonLd("faq-fusion-jpg-pdf", faqJsonLd);

  useJsonLd("breadcrumb-fusion-jpg-pdf", {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        name: "Accueil",
        item: "https://pdf-convert.fr/home",
      },
      {
        "@type": "ListItem",
        position: 2,
        name: "Fusion",
        item: "https://pdf-convert.fr/fusion",
      },
      {
        "@type": "ListItem",
        position: 3,
        name: "Fusion JPG→PDF",
        item: "https://pdf-convert.fr/fusion-jpg-pdf",
      },
    ],
  });

  return (
    <main style={{ maxWidth: 900, margin: "0 auto", padding: 16 }}>
      <h1>Fusion JPG → PDF</h1>
      <p style={{ textAlign: "center", color: "#666" }}>
        Regroupe plusieurs images en un PDF A4. Ordre modifiable. Aucun envoi.
      </p>

      <ImagesToPdf />
    </main>
  );
}
